<template>
  <institution-picker-dialog :preselect="preselect" :preselect-name="preselectName" :employee="employee" :value="value" mode="plan" @input="$emit('input', $event)" @update:employee="$emit('update:employee')"/>
</template>

<script lang="ts">
import Vue from 'vue';
import {Employee} from '@/interfaces/employee.interface';
import InstitutionPickerDialog from './institutionPicker/institutionPickerDialog.vue';

/** Standorte vormerken for a teacher / applicant with ranked suggestions (application choice, availability, air-line distance, demand); saving lives in institutionPickerDialog */
export default Vue.extend({
  components: {InstitutionPickerDialog},
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    employee: {
      type: Object as () => Employee,
      required: true,
    },
    /** Optional id added to the selection on open (near views) */
    preselect: {type: String, default: ''},
    preselectName: {type: String, default: ''},
  },
});
</script>
